import { Department, DgtPdIAMUser } from "../models";
import { useEffect, useState } from 'react'
import { 
  userByDepartment
} from '../graphql/queries'
import { API } from 'aws-amplify'

export default function useUsers(department: Department, refresh: boolean, division?: string, line?: string) : DgtPdIAMUser[] {
  const [users, setUsers] = useState<DgtPdIAMUser[]>([]);
  useEffect(() => {
    const fetchUsersByDepartment = async(dep: Department, div?: string, lin?: string) => {
      let variables = {
        department: dep,
        filter: {},
        limit: 500
      }
      if (div) {
        variables.filter = { ...variables.filter, division: { eq: div }}
      }

      if (lin) {
        variables.filter = { ...variables.filter, line: { eq: lin }}
      }
      const userResult : any = await API.graphql({
        query: userByDepartment,
        variables
      })
      const users : DgtPdIAMUser[] = userResult.data?.userByDepartment ? userResult.data?.userByDepartment.items : []
      setUsers(users)
    }
    fetchUsersByDepartment(department, division, line)
  }, [ department, division, refresh, line ])

  return users
}